"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fbq = exports.gtag = void 0;
var reconnect_js_1 = require("reconnect.js");
var gtag = function (eventType, event, payload) {
    try {
        if (typeof window === 'undefined') {
            return;
        }
        var featureOptions = reconnect_js_1.getOutlet('FeatureOptions').getValue();
        if (!featureOptions.googleAnalytics) {
            return;
        }
        var shouldContinue = reconnect_js_1.getOutlet('actions')
            .getValue()
            .gtag(eventType, event, payload);
        if (!shouldContinue) {
            return;
        }
        var _window = window;
        _window.gtag(eventType, event, payload);
    }
    catch (e) {
        console.log('google analytics is not ready');
    }
};
exports.gtag = gtag;
var fbq = function (eventType, event, payload) {
    try {
        if (typeof window === 'undefined') {
            return;
        }
        var featureOptions = reconnect_js_1.getOutlet('FeatureOptions').getValue();
        if (!featureOptions.facebookPixel) {
            return;
        }
        var shouldContinue = reconnect_js_1.getOutlet('actions')
            .getValue()
            .fbq(eventType, event, payload);
        if (!shouldContinue) {
            return;
        }
        var _window = window;
        _window.fbq(eventType, event, payload);
    }
    catch (e) {
        console.log('facebook pixel is not ready');
    }
};
exports.fbq = fbq;
var findNameKey = function (item) { return item.name || item.title; };
var tracker = {
    signUp: function (_a) {
        var method = _a.method;
        gtag('event', 'sign_up', { method: method });
        fbq('track', 'CompleteRegistration', {
            method: method,
        });
    },
    login: function (_a) {
        var user = _a.user;
        gtag('event', 'login', {
            method: user.data.provider,
        });
        gtag('set', 'user_id', user.data.owner);
        gtag('set', 'user_properties', {
            provider: user.data.provider,
            email: user.data.email,
        });
    },
    addToCart: function (_a) {
        var product = _a.product, quantity = _a.quantity;
        gtag('event', 'add_to_cart', {
            currency: 'TWD',
            value: product.price * quantity,
            items: [product].map(function (p) { return ({
                item_id: p.id,
                item_name: p.name,
            }); }),
        });
    },
    removeFromCart: function (_a) {
        var cartItem = _a.cartItem;
        gtag('event', 'remove_from_cart', {
            currency: 'TWD',
            value: cartItem.product.price,
            items: [
                {
                    item_id: cartItem.product.id['$oid'],
                    item_name: cartItem.product.name,
                },
            ],
        });
    },
    purchase: function (_a) {
        var _b, _c;
        var order = _a.order;
        gtag('event', 'purchase', {
            transaction_id: order.order_number,
            currency: 'TWD',
            value: order.total,
            coupon: ((_b = order.discount_items.find(function (i) { return i.type === 'coupon'; })) === null || _b === void 0 ? void 0 : _b.coupon.code) || undefined,
            shipping: ((_c = order.extra_items.find(function (i) { return i.name === '運費'; })) === null || _c === void 0 ? void 0 : _c.amount) || 0,
            tax: order.tax,
            items: order.items.map(function (i) {
                var _a;
                return ({
                    item_id: ((_a = i.product.id) === null || _a === void 0 ? void 0 : _a['$oid']) || 'custom_product',
                    item_name: i.product.name,
                    price: i.product.price,
                    quantity: i.config.qty,
                });
            }),
        });
        fbq('track', 'Purchase', {
            content_name: 'order',
            content_ids: order.items.map(function (i) { return i.product.id['$oid']; }),
            contents: order.items.map(function (i) { return ({
                id: i.product.id['$oid'],
                quantity: i.config.qty,
            }); }),
            content_type: 'product_group',
            num_items: order.items.length,
            currency: 'TWD',
            value: order.total,
        });
    },
    keywordSearch: function (_a) {
        var keyword = _a.keyword;
        gtag('event', 'search', {
            search_term: keyword,
        });
        fbq('track', 'Search', {
            content_category: 'product_list',
            search_string: keyword,
            currency: 'TWD',
        });
    },
    beginCheckout: function (_a) {
        var cart = _a.cart;
        gtag('event', 'begin_checkout', {
            currency: 'TWD',
            value: cart.total,
            items: cart.items.map(function (i) { return ({
                item_id: i.product.id['$oid'],
                item_name: i.product.name,
            }); }),
        });
        fbq('track', 'InitiateCheckout', {
            content_category: 'checkout',
            content_ids: cart.items.map(function (i) { return i.product.id['$oid']; }),
            contents: cart.items.map(function (i) { return ({
                id: i.product.id['$oid'],
                quantity: i.config.qty,
            }); }),
            num_items: cart.items.length,
            currency: 'TWD',
            value: cart.total,
        });
    },
    viewCart: function (_a) {
        var cart = _a.cart;
        gtag('event', 'view_cart', {
            currency: 'TWD',
            value: cart.total,
            items: cart.items.map(function (i) { return ({
                item_id: i.product.id['$oid'],
                item_name: i.product.name,
            }); }),
        });
    },
    addCheckoutInfo: function (_a) {
        var cart = _a.cart;
        gtag('event', 'add_payment_info', {
            currency: 'TWD',
            value: cart.total,
            payment_type: 'ecpay',
            payment_subtype: cart.payment_subtype,
            items: cart.items.map(function (i) { return ({
                item_id: i.product.id['$oid'],
                item_name: i.product.name,
            }); }),
        });
        gtag('event', 'add_shipping_info', {
            currency: 'TWD',
            value: cart.total,
            logistics_type: cart.logistics_type,
            logistics_subtype: cart.logistics_subtype,
            items: cart.items.map(function (i) { return ({
                item_id: i.product.id['$oid'],
                item_name: i.product.name,
            }); }),
        });
        fbq('track', 'AddPaymentInfo', {
            content_category: 'checkout',
            content_ids: cart.items.map(function (i) { return i.product.id['$oid']; }),
            contents: cart.items.map(function (i) { return ({
                id: i.product.id['$oid'],
                quantity: i.config.qty,
            }); }),
            currency: 'TWD',
            value: cart.total,
        });
    },
    selectItem: function (_a) {
        var name = _a.name, item = _a.item;
        gtag('event', 'select_item', {
            item_list_name: name,
            items: [
                {
                    item_id: item.id,
                    item_name: findNameKey(item),
                },
            ],
        });
    },
    viewItem: function (_a) {
        var _b;
        var name = _a.name, item = _a.item;
        gtag('event', 'view_item', {
            currency: 'TWD',
            value: item.price,
            items: [item].map(function (p) { return ({
                item_id: p.id,
                item_name: findNameKey(p),
            }); }),
        });
        fbq('track', 'ViewContent', {
            content_ids: [item.id],
            content_category: (_b = item.labels) === null || _b === void 0 ? void 0 : _b.join(','),
            content_name: item.name,
            currency: 'TWD',
            value: item.price,
            contents: [item].map(function (p) { return ({
                id: item.id,
                quantity: 1,
            }); }),
            content_type: name,
        });
    },
    viewList: function (_a) {
        var name = _a.name, list = _a.list;
        gtag('event', 'view_item_list', {
            item_list_name: name,
            items: list.map(function (p) { return ({
                item_id: p.id,
                item_name: findNameKey(p),
            }); }),
        });
    },
    share: function (_a) {
        var name = _a.name, item = _a.item, method = _a.method;
        gtag('event', 'share', {
            method: method,
            content_type: name,
            item_id: item.id,
        });
    },
};
exports.default = tracker;
